import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { UPDATE_CASE } from "@store/cases/casesActions";
import { updateCaseQuestions } from "@store/cases/casesSlice";
import { Case, CaseUpdate, CaseUpdateInput } from "@types-runway/case";

import { cases } from "../../api";

const useCase = () => {
  const dispatch = useDispatch();
  const updateCase = useCallback(
    (id: number, isAuth: boolean, caseUpdateInput: CaseUpdateInput) => {
      const { UserId, questions, ...formattedUpdateBody } = caseUpdateInput;

      let updateBody: CaseUpdate = formattedUpdateBody;

      if (questions) {
        // It filters answered questions
        const answeredQuestions = Object.values(questions).filter((item) => item.answer !== "");
        dispatch(updateCaseQuestions(answeredQuestions));
        updateBody.case_questions = answeredQuestions;
      }

      if (UserId) {
        updateBody.UserId = UserId;
      }

      dispatch({
        type: UPDATE_CASE,
        caseId: id,
        isAuth,
        updateBody,
      });
    },
    [dispatch]
  );

  const fetchCaseDetails = useCallback(async (id: number): Promise<Case | null> => {
    try {
      const { data } = await cases.caseGet(`/${id}`);
      return data;
    } catch (error) {
      return null;
    }
  }, []);

  return {
    updateCase,
    fetchCaseDetails,
  };
};

export default useCase;
